import { render } from "./VImg.vue?vue&type=template&id=30e61f4c"
import script from "./VImg.vue?vue&type=script&lang=js"
export * from "./VImg.vue?vue&type=script&lang=js"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__